import { makeStyles } from '@material-ui/core/styles';
import ApplicationStyles from 'app/styles/ApplicationStyles';

export const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    // SelectorContainer: {
    //     display: 'flex',
    //     flexWrap: 'wrap',
    //     alignItems: 'center',
    //     padding: '10px',
    // },
    // selectBox: {
    //     display: 'flex',
    //     flexWrap: 'wrap',
    //     flexDirection: 'row',
    //     alignItems: 'center',
    //     height: 'auto',
    // },
    Select: {
        margin: 5,
        width: 350,
    },
    ButtonGroup: {
        display: 'flex',
        alignItems: 'center',
        padding: 10,
    },
    Button: {
        width: '90%',
        height: '45px',
    },
}));


export const styles = ({
    ...ApplicationStyles.margins,
    ...ApplicationStyles.flexBox,
	titleBox: {
        ...ApplicationStyles.margins.baseHorizontalMargin,
        ...ApplicationStyles.margins.smallVerticalMargin
    },
    inputSelect:{
    	width: '100%',
    	paddingRight: 8,
        paddingBottom: 8,
    }
})